import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'

const DatosGenerales = () => {
    const location = useLocation()

    const [render, setRender] = useState<stateComponentComplete>({ ready: false})
    useEffect(() => {
        if (render.ready) sendDataLayer('onload-HomeAviso', location.pathname)
        setRender({ ready: true})
    }, [location.pathname, render.ready])
    return (
        <main className='container_aviso'>
            <section className='container_av_priv'>
                <h1 className='title_aviso'>Aviso de Privacidad Integral - Grupo Profuturo</h1>
                <div className='container_general'>
                    <p className='sub_ident'>Identidad y domicilio del Responsable</p>
                    <p className='text_general'>
                        <span className='span_text_aviso'>Grupo Profuturo, S.A.B. de C.V.</span> (en adelante "Profuturo") con domicilio en Boulevard Adolfo López Mateos número 2009, 
                        Colonia Los Alpes, Álvaro Obregón, C.P. 01010, Ciudad de México
                    </p>

                    <div className='divider'></div><br />

                    <p className='subtitle_aviso'>Datos personales tratados</p>
                    <p className='text_general'>
                        Para llevar a cabo las finalidades descritas en el presente aviso de privacidad trataremos las siguientes categorías de datos personales:<br/><br/>
                        <ul>
                            <li>Datos de identificación y contacto</li>
                        </ul>
                    </p><br />
                    <p className='subtitle_aviso'>Datos personales sensibles</p>
                    <p className='text_general'>
                        No daremos tratamiento a datos personales sensibles
                    </p><br />
                    <p className='subtitle_aviso'>Datos personales de menores de edad</p>
                    <p className='text_general'>
                    Profuturo no recaba, utiliza ni trata datos personales de menores de edad de manera directa. Únicamente se podrán llegar a tratar cuando dichos datos sean 
                    proporcionados voluntariamente por la persona que ejerza la patria potestad, tutela o representación legal del menor. En este supuesto, quien proporcione 
                    los datos personales manifiesta y declara, bajo protesta de decir verdad, que ostenta la patria potestad o representación legal correspondiente del menor 
                    cuyos datos personales facilita, asumiendo la responsabilidad derivada de dicha declaración.
                    </p><br />

                    <div className='divider'></div><br />
                </div>
            </section>
        </main>
    )
}

export default DatosGenerales